import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 9, viewBox: "0 0 9 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.48 8.68V5.12H0V3.46H3.48V0H5.2V3.46H8.68V5.12H5.2V8.68H3.48Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
